import { Layout } from "@/components/layout/Layout";
import { TemplateDetailView } from "@/components/template/TemplateDetail";

interface TemplateDetailPageProps {
  templateId: string;
}

export function TemplateDetailPage({ templateId }: TemplateDetailPageProps) {
  return (
    <Layout>
      {/* Edge-to-edge: the detail view fills the viewport and manages its
          own internal scrolling (panes scroll, the page does not). */}
      <div className="h-full">
        <TemplateDetailView templateId={templateId} />
      </div>
    </Layout>
  );
}
